export const Footer = () => {
    return (
        <div className="footer">
            &copy; 2023 gambling-list.com
        </div>
    );
};